import { render, staticRenderFns } from "./comprovativoNovo.vue?vue&type=template&id=0d8c7d39&scoped=true&"
import script from "./comprovativoNovo.vue?vue&type=script&lang=js&"
export * from "./comprovativoNovo.vue?vue&type=script&lang=js&"
import style0 from "./comprovativoNovo.vue?vue&type=style&index=0&id=0d8c7d39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c7d39",
  null
  
)

export default component.exports